/* eslint-disable prettier/prettier */
import { UploadCloud, X } from 'lucide-react';
import { useRef } from 'react';

type LogoUploadProps = {
  file: File | null;
  onFileSelect: (file: File | null) => void;
};

export const LogoUpload = ({ file, onFileSelect }: LogoUploadProps) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0] || null;
    if (
      selectedFile &&
      ['image/png', 'image/jpeg', 'image/jpg'].includes(selectedFile.type)
    ) {
      onFileSelect(selectedFile);
    }
  };

  return (
    <div className="mt-4">
      {file ? (
        <div className="flex items-center justify-between w-full px-4 py-2 border-[1.5px] rounded-lg border-secondary bg-white">
          <p className="text-sm truncate text-primary">{file.name}</p>
          <button onClick={() => onFileSelect(null)}>
            <X className="w-4 h-4 text-primary" />
          </button>
        </div>
      ) : (
        <div
          onClick={() => fileInputRef.current?.click()}
          className="flex items-center justify-start gap-2 px-4 py-2 border-[1.5px] rounded-lg border-secondary bg-white cursor-pointer hover:border-primary hover:bg-highlight transition"
        >
          <UploadCloud className="w-4 h-4 text-primary" />
          <span className="text-sm font-medium text-primary">+ Add a logo</span>
        </div>
      )}
      <input
        type="file"
        accept=".png,.jpg,.jpeg"
        ref={fileInputRef}
        onChange={handleFileChange}
        className="hidden"
      />
    </div>
  );
};
